import { NavLink, Outlet } from 'react-router-dom'
import {
  Building2,
  MessagesSquare,
  FileText,
  Mail,
  Receipt,
  Rocket,
  ScrollText,
  RotateCw,
  Scale,
  Send,
  ShieldCheck,
  Users,
  UserCircle,
} from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import { useVerifactuConfig } from '../../lib/verifactu'

const navItems = [
  { to: '/settings/profile', label: 'Mi perfil', icon: UserCircle, adminOnly: false },
  { to: '/settings/security', label: 'Seguridad', icon: ShieldCheck, adminOnly: false },
  { to: '/settings/users', label: 'Usuarios', icon: Users, adminOnly: true },
  { to: '/settings/firm', label: 'Bufete', icon: Building2, adminOnly: true },
  { to: '/settings/billing', label: 'Facturación', icon: Receipt, adminOnly: true },
  { to: '/settings/email', label: 'Correo saliente', icon: Send, adminOnly: true },
  { to: '/settings/channels', label: 'Canales', icon: MessagesSquare, adminOnly: false },
  { to: '/settings/recurring', label: 'Igualas', icon: RotateCw, adminOnly: true },
  { to: '/settings/templates', label: 'Plantillas de escritos', icon: FileText, adminOnly: false },
  { to: '/settings/email-templates', label: 'Plantillas de email', icon: Mail, adminOnly: false },
  { to: '/settings/litigation', label: 'Procesal', icon: Scale, adminOnly: true },
  { to: '/settings/verifactu', label: 'Verifactu', icon: ShieldCheck, adminOnly: true },
  {
    to: '/settings/verifactu-declaration',
    label: 'Declaración responsable',
    icon: ScrollText,
    adminOnly: false,
    needsVerifactu: true,
  },
  { to: '/onboarding', label: 'Primeros pasos', icon: Rocket, adminOnly: false },
]

export default function SettingsLayout() {
  const auth = useAuth()
  const isAdmin = auth.status === 'authenticated' && auth.user.role === 'ADMIN'
  const vf = useVerifactuConfig()

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-6 animate-slideUp">
      <aside>
        <nav className="surface p-2 flex flex-col gap-1">
          {navItems
            .filter(
              (i) => (!i.adminOnly || isAdmin) && (!('needsVerifactu' in i) || vf?.enabled === true)
            )
            .map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                end
                className={({ isActive }) =>
                  [
                    'flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition',
                    isActive
                      ? 'bg-toga-500/15 text-toga-200 shadow-glow-toga'
                      : 't-secondary hover:bg-hover',
                  ].join(' ')
                }
              >
                <Icon size={16} />
                {label}
              </NavLink>
            ))}
        </nav>
      </aside>
      <section>
        <Outlet />
      </section>
    </div>
  )
}
